// extracted by mini-css-extract-plugin
module.exports = {"Root":"slider_Root__oR4K3","Track":"slider_Track__TREOU","Range":"slider_Range__biwOx","Thumb":"slider_Thumb__wjxog"};